import { MapPin, Phone, Navigation } from "lucide-react";
import { PageHero } from "@/components/sections/PageHero";
import { LeadSection } from "@/components/sections/LeadSection";
import { Reveal } from "@/components/motion/Reveal";
import { COMPANY, IMG } from "@/data/site";

const Card = ({ icon: Icon, label, children, testId }) => (
  <div className="rounded-[24px] border border-white/5 bg-ink-800 p-8" data-testid={testId}>
    <Icon className="h-5 w-5 text-volt" />
    <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">{label}</p>
    <div className="mt-2 font-display text-xl font-semibold text-white">{children}</div>
  </div>
);

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero testId="contact-hero" eyebrow="Contact" lines={["Let's Talk", "Equipment"]} img={IMG.jukeboxAtomic} sub="Call, visit, or send a request. We'll help you find the right equipment for your location." />
      <section className="py-24">
        <div className="container-x grid gap-5 lg:grid-cols-12">
          <div className="grid gap-5 lg:col-span-4">
            <Reveal><Card icon={Phone} label="Call" testId="contact-phone-card"><a href={COMPANY.tel} className="transition-colors hover:text-volt" data-testid="contact-phone-link">{COMPANY.phone}</a></Card></Reveal>
            <Reveal delay={0.08}><Card icon={MapPin} label="Visit" testId="contact-address-card">{COMPANY.name}<br /><span className="text-slate-300">{COMPANY.street}<br />{COMPANY.city}</span></Card></Reveal>
            <Reveal delay={0.16}>
              <a href={COMPANY.directions} target="_blank" rel="noreferrer" className="btn-ghost h-14 w-full text-sm" data-testid="contact-directions-link"><Navigation className="h-4 w-4 text-volt" /> Get Directions</a>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="lg:col-span-8">
            <div className="h-[420px] overflow-hidden rounded-[24px] border border-white/5 lg:h-full lg:min-h-[480px]">
              <iframe title="Brewer Amusement location" src={COMPANY.map} className="h-full w-full grayscale invert-[0.92] hue-rotate-180" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="contact-map" />
            </div>
          </Reveal>
        </div>
      </section>
      <LeadSection index="01" source="contact-page" />
    </div>
  );
}
